import { render, staticRenderFns } from "./GoodsSkuSelect.vue?vue&type=template&id=184767b8"
import script from "./GoodsSkuSelect.vue?vue&type=script&lang=js"
export * from "./GoodsSkuSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports